export const MIXPANEL_FORWARD_PATH = '/mpf';
export const MIXPANEL_FORWARD_EVENT_PATH = `${MIXPANEL_FORWARD_PATH}/event`;
